import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getMachineType } from "../../../actions/reports/machine_type";
import PropTypes from "prop-types";
import MDButton from "../../MDButton";
import { getMachineGroup } from "../../../actions/machine-group/machine-group";
import Paginate from "../../Paginate/Paginate";
import { useSearchParams } from "react-router-dom";
import { getDrivers } from "../../../actions/driver/driver";
import { CircularProgress } from "@mui/material";

ModalDriverSingleWithData.propTypes = {
  showModal: PropTypes.any,
  setShowModal: PropTypes.any,
  setData: PropTypes.any,
  onSelectedIdsChange: PropTypes.any,
  data: PropTypes.any,
};
export default function ModalDriverSingleWithData({
  data,
  showModal,
  setShowModal,
  setData,
  onSelectedIdsChange,
}) {
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();


  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const allIds = data.map((item) => item.id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };


  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center w-full items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="w-full relative my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-2xl font-semibold">انتخاب راننده</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
          <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
            ×
          </span>
                  </button>
                </div>
                {loading ? (
                  <div className="flex p-6 flex-auto justify-center items-center">
                    <CircularProgress size={30} color={"info"} />
                  </div>
                ) : (
                  <div className="flex p-6 flex-auto justify-start items-start">
                    <div className="overflow-y-auto h-52 w-full">
                      <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="text-center">
                            ردیف
                          </th>
                          <th scope="col" className="text-center">
                            نام و نام خانوادگی
                          </th>
                          <th scope="col" className="text-center">
                            کدملی
                          </th>
                          <th scope="col" className="text-center">
                            شماره موبایل
                          </th>
                          <th scope="col" className="text-center">
                            عملیات
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((item, index) => (
                          <tr
                            key={index}
                            className={`bg-white ${
                              index !== data.length - 1 ? "border-b border-gray" : ""
                            } dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 w-full`}
                          >
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white text-center">
                              {item.id}
                            </th>
                            <td className="px-6 py-4 text-center">{item.name}</td>
                            <td className="px-6 py-4 text-center">{item.melli_code === 'null' ? '--' : item.melli_code}</td>
                            <td className="px-6 py-4 text-center">{item.cellphone === 'null' ? '--' : item.cellphone}</td>
                            <td className="w-4 p-4 text-center">
                              <div className="flex items-center justify-center">
                                <MDButton
                                  color={"info"}
                                  className="background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                  type="button"
                                  onClick={() => {
                                    onSelectedIdsChange({ title: item.name, id: item.id });
                                    setShowModal(false);
                                  }}
                                >
                                  انتخاب
                                </MDButton>
                              </div>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {/*footer*/}
                <div className="gap-5 flex items-center justify-start p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <MDButton
                    color={"error"}
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    انصراف
                  </MDButton>
                </div>
              </div>
            </div>
          </div>

          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
